// extracted by mini-css-extract-plugin
module.exports = {"colTable":"style_colTable__3Jr1F","titleCol":"style_titleCol__3uMa_","formItem":"style_formItem__e956C"};